export const SET_BASE_INFO = 'set_base_info';
export const CLEAR_DATA = 'clear_data';
export const SET_OWNER_INFO = 'set_owner_info';
export const GET_GROUP_INFO = 'get_group_info';
